module.exports = __webpack_public_path__ + "img/transaction.b7ae366d.png";